import styled from 'styled-components'

export const Container = styled.div`
  > * {
    &:first-child {
      margin-top: 0;
      font-weight: ${props => props.theme.font.default.bold};
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`
